import './polyfills';
import './utils/saveButtonDefaults';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './styles/notifyOverride.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import dateBox from 'devextreme/ui/date_box';
import { injectQuickDatePresets } from './utils/dateQuickPresets';

dateBox.defaultOptions({
  options: {
    onOpened: (e) => {
      injectQuickDatePresets(e?.component);
    }
  }
});

// Disable StrictMode in development to avoid double-invocation side effects
const rootContent = process.env.NODE_ENV === 'development'
  ? <App />
  : (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

ReactDOM.render(
  rootContent,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
